import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import isEmpty from 'lodash/isEmpty';
import Modal from 'components/common/Modal';
import { Button, ButtonVariant } from 'components/common/buttons/Button';
import { IndividualPayrocMerchantAccount } from 'api/admin/businesses/getPayrocMerchantAccounts';
import styles from './EditMerchantAccountModal.module.scss';
import { useAddPayrocMerchant } from './mutations/useAddPayrocMerchant';
import { useEditPayrocMerchant } from './mutations/useEditPayrocMerchant';

export const EditMerchantAccountModal: FC<{
  isNew: boolean;
  businessId: number;
  merchant: IndividualPayrocMerchantAccount | null;
  onClose: (shouldReload: boolean) => void;
}> = ({ isNew, businessId, merchant, onClose }) => {
  const [merchantId, setMerchantId] = useState<string | null>(merchant?.merchantId ?? null);

  const { mutateAsync: onAddPayrocMerchant } = useAddPayrocMerchant();
  const { mutateAsync: onEditPayrocMerchant } = useEditPayrocMerchant();

  const handleMerchantIdChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setMerchantId(value);
  };

  const handleSave = async () => {
    if (isNew) {
      await onAddPayrocMerchant({ businessId, merchantId });
    } else {
      await onEditPayrocMerchant({ businessId, merchantId, payrocMerchantAccountId: merchant?.id });
    }

    onClose(true);
  };

  return (
    <Modal modalHeight="300px" onClose={() => onClose(false)}>
      <div className={styles.editMerchantFormContainer}>
        <h1 className={styles.editMerchantFormContainerHeader}>
          {`${isNew ? 'Add' : 'Edit'} Merchant Account`}
        </h1>
        <div className={styles.editMerchantFormContainerRow}>
          <p>Merchant Id</p>
          <TextField
            variant="outlined"
            type="number"
            value={merchantId}
            onChange={handleMerchantIdChange}
          />
        </div>
        <Button
          isDisabled={isEmpty(merchantId)}
          type={ButtonVariant.CONTAINED}
          onClick={handleSave}
          style={{ width: '150px' }}
        >
          {`${isNew ? 'Add' : 'Save'}`}
        </Button>
      </div>
    </Modal>
  );
};
